<main role="main" class="not-home-page">
    <div class="row">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="banner"><img src="" alt="" /></div>
            <app-breadcrumb></app-breadcrumb>
          
          </div>
          <div class="col-md-3 side-bar">
            <div class="selected-item">      </div> 
            <nav id="sidebar">
              <app-statique-menu
                [lg]="currentLg"
                [cururl]="'/acces-rapide/contact'"
              ></app-statique-menu>
            </nav>
          </div>
          <div style="padding-left:20px" class="col-md-9">
            <section class="content-side">
              <div class="container">
                <div class="row">
                  <div class="col-lg-10 col-md-10 col-s-12">
                  <h3>{{"header.contact" | translate }}</h3>
                  <div [innerHTML]="bloc.Titre"></div>
                  <div [innerHTML]="bloc.Contenu"></div>
                  </div>
                </div>
                <div class="row">

                  <form #form1="ngForm" [ngFormOptions]="{updateOn: 'blur'}" >
                    <div class="col-lg-10 col-md-10 col-s-12">
                      <div class="row">
                          <div class="col-lg-6 col-md-6 col-s-12" class="titleField">
                              <p>{{"contact.Nom" | translate }} *:</p>
                          </div>
                          <div class="col-lg-6 col-md-6 col-s-12">
                              <input  ngModel required type="text" name="Nom">
                          </div>
                      </div>
                      <div class="row">
                          <div class="col-lg-6 col-md-6 col-s-12" class="titleField">
                              <p>{{"contact.Prenom" | translate }} *:</p>
                          </div>
                          <div class="col-lg-6 col-md-6 col-s-12">
                              <input  ngModel required  type="text" name="Prenom">
                          </div>
                      </div>
                      <div class="row">
                          <div class="col-lg-6 col-md-6 col-s-12" class="titleField">
                              <p>{{"contact.Telephone" | translate }} *:</p>
                          </div>
                          <div class="col-lg-6 col-md-6 col-s-12">
                              <input (keypress)="keyPressPhone($event)" ngModel required  type="text" name="Telephone">
                          </div>
                      </div>
                      <div class="row">
                          <div class="col-lg-6 col-md-6 col-s-12" class="titleField">
                              <p>{{"contact.Ville" | translate }} *:</p>
                          </div>
                          <div class="col-lg-6 col-md-6 col-s-12">
                              <input   ngModel  type="text" name="Ville">
                          </div>
                      </div>
                      <div class="row">
                          <div class="col-lg-6 col-md-6 col-s-12" class="titleField">
                              <p>{{"contact.Pays" | translate }} *:</p>
                          </div>
                          <div class="col-lg-6 col-md-6 col-s-12">
                              <input ngModel  type="text" name="Pays">
                          </div>
                      </div>
                      <div class="row">
                          <div class="col-lg-6 col-md-6 col-s-12" class="titleField">
                              <p>{{"contact.Email" | translate }} *:</p>
                          </div>
                          <div class="col-lg-6 col-md-6 col-s-12">
                              <input  ngModel required email ngModel type="email" name="Email">
                          </div>
                      </div>
                      <div class="row">
                          <div class="col-lg-6 col-md-6 col-s-12" class="titleField">
                              <p>{{"contact.ObjetContact" | translate }} *:</p>
                          </div>
                          <div class="col-lg-6 col-md-6 col-s-12">
                              <input ngModel required type="text" name="Sujet">
                          </div>
                      </div>
                      <div class="row">
                          <div class="col-lg-6 col-md-6 col-s-12" class="titleField">
                              <p>{{"contact.Message" | translate }} *:</p>
                          </div>
                          <div class="col-lg-6 col-md-6 col-s-12">
                              <textarea class="textArea" ngModel required type="text" name="Message"></textarea>
                          </div>
                      </div>
                      <div class="row">
                          <div align="left" class="col-lg-12 col-md-12 col-s-12" >
                              <div class="btn_form filtre">
                                <button style="margin:10px" [disabled]="form1.control.status !=='VALID'" class="btn btn-primary" (click)="addContact (form1)" type="button">{{"contact.Envoyer" | translate }}</button> 
                                <button  style="margin:10px" class="btn btn-primary" (click)="resetData(form1)"type="button">{{"contact.Annuler" | translate }}</button> 
                                
                              </div>
                          </div>
                      </div>
           

                  </div>
                  <div class="col-lg-2 col-md-2 col-s-12">
                      
                  </div>
                  </form>


                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  </main>
  